import { render } from "./SidebarItem.vue?vue&type=template&id=6da612df&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"

import "./SidebarItem.vue?vue&type=style&index=0&id=6da612df&lang=scss&scoped=true"

import exportComponent from "/Users/dongyucheng/小飞蛾/哈尔滨超付商务信息咨询服务有限公司/code/lxk_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da612df"]])

export default __exports__